import React, { useEffect, useState } from "react";
import { useDataProvider, useNotify, useRecordContext } from "react-admin";
import { Grid, LinearProgress, Typography } from "@material-ui/core";
import SanitizedGrid from "../../../components/SanitizedGrid";
import RoutePriceComponent from "./RoutePriceComponent";

const SubcontractorAdjustmentPricePanel = () => {
  const record = useRecordContext();
  const provider = useDataProvider();
  const notify = useNotify();

  const [remark, setRemark] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (record && record?.status === "rejected") {
      setIsLoading(true);
      provider
        .getList("subcontractorAdjustmentPriceStatusLogs", {
          filter: {
            SubcontractorAdjustmentPriceId: record.id,
            NewStatus: "rejected",
          },
          sort: {
            field: "loggedAt",
            order: "DESC",
          },
          pagination: {
            page: 1,
            perPage: 1,
          },
        })
        .then((response) => {
          const subcontractorAdjustmentPriceStatusLogs =
            response.data as ISubcontractorAdjustmentPriceStatusLog[];
          if (subcontractorAdjustmentPriceStatusLogs.length > 0) {
            setRemark(subcontractorAdjustmentPriceStatusLogs[0].remark);
          }
        })
        .catch((error) => {
          notify(`Error, ${error.message}`, "warning");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  return (
    <SanitizedGrid
      container
      spacing={2}
      style={{ padding: "5px 10px 5px 45px" }}
    >
      {record?.status === "rejected" && (
        <>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Remarks</Typography>
          </Grid>

          <Grid item xs={12}>
            {isLoading ? (
              <LinearProgress />
            ) : (
              <Typography variant="body2">{remark}</Typography>
            )}
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <Typography variant="subtitle2">Adjustment Price Preview</Typography>
      </Grid>

      <Grid item xs={12}>
        <RoutePriceComponent
          routeId={record?.routeId}
          subcontractorId={record?.subcontractorId}
          schoolId={record?.schoolId}
          price={Number(record?.price) / 100}
          viewType="table"
        />
      </Grid>
    </SanitizedGrid>
  );
};

export default SubcontractorAdjustmentPricePanel;
